import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const ResidentAdvisor = ({ className, color }) => (
  <svg
    className={ className }
    { ...iconCommonProps }
    viewBox='0 0 45.37 21.76'
  >
    <g>
      <path
        d='M44.88,17.41a1.58,1.58,0,0,0,.49-1.14,1.63,1.63,0,0,0-.49-1.12L32.07,2.34,28.2,6.21,38.29,16.29H24a2.43,2.43,0,0,1-1.72-.71L15.87,9.17a3.76,3.76,0,0,0-2.57-1H5.47V5.47h8.1a5.75,5.75,0,0,1,4.09,1.71L22.44,12,26.31,8.1,21.44,3.22A11.14,11.14,0,0,0,13.56,0H0V13.61H11.47a2.68,2.68,0,0,1,1.9.81l6.28,6.28a3.75,3.75,0,0,0,2.46,1.06H39.46A2.69,2.69,0,0,0,41.33,21l3.55-3.55Z'
        fill={ color }
      />
      <path
        className='cls-1'
        d='M35.05,0a1.59,1.59,0,0,0-1.58,1.59h0a1.58,1.58,0,0,0,1.58,1.59,1.6,1.6,0,0,0,1.59-1.6h0A1.58,1.58,0,0,0,35.05,0m1.41,1.59A1.4,1.4,0,0,1,35.05,3a1.39,1.39,0,0,1-1.4-1.41h0a1.41,1.41,0,1,1,2.81,0Z'
      />
      <path
        className='cls-1'
        d='M34.47.77h.77c.35,0,.53.16.53.44a.38.38,0,0,1-.27.4h0c.1,0,.24.08.24.34a.7.7,0,0,0,.09.42h-.3a.37.37,0,0,1-.05-.23c0-.3-.06-.43-.32-.43h-.41v.66h-.28Zm.28.74h.46c.18,0,.28-.09.28-.26S35.35,1,35.21,1h-.46Z'
      />
    </g>
  </svg>
);

ResidentAdvisor.propTypes = { ...iconPropTypes };

ResidentAdvisor.defaultProps = { ...iconDefaultProps };

export default ResidentAdvisor;